// extracted by mini-css-extract-plugin
module.exports = {"ResultItem":"styles_ResultItem__fOiy6","hideOnSmallScreen":"styles_hideOnSmallScreen__9Pa6C","hideOnLargeScreen":"styles_hideOnLargeScreen__6ufzB"};